import React, { useContext } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import Box from '@material-ui/core/Box'

import { BudgetContext } from './context'
import { DetailedBudget } from '@components/DetailedBudget'
import { SimpleBudget } from './SimpleBudget'
import { CheckboxWithLabel } from '../../components/Form/Fields'
import { ActionablesContext } from '../../contexts/ActionablesContext'
import useMediaQuery from '@material-ui/core/useMediaQuery'

export const BudgetTabs = () => {
  // See breakpoints.sass for different breakpoints we use
  const enableDetailedBudget = useMediaQuery('(min-width:640px)')
  const {
    state: { budget, selectedTab, isRetired, budgetCategories },
    actions: { setSelectedTab }
  } = useContext(BudgetContext)
  const { readOnly } = useContext(ActionablesContext)
  const { selected } = budget

  return (
    <Tabs
      selectedIndex={!enableDetailedBudget ? 0 : selectedTab}
      onSelect={(index) => setSelectedTab(index)}
      className='app-tabs'
    >
      <TabList className='app-tabs__list flex flex-col xs:flex-row'>
        <TabHeader selected={selected} selectedTab={selectedTab} enableDetailedBudget={enableDetailedBudget} />
        <div className='flex justify-end'>
          <Tab
            className='app-tabs__list-item'
            selectedClassName='app-tabs__list-item--selected'>Simple expenses</Tab>
          {enableDetailedBudget &&
            <Tab
              className='app-tabs__list-item'
              selectedClassName='app-tabs__list-item--selected'>Detailed expenses</Tab>
          }
        </div>
      </TabList>
      <TabPanel>
        <SimpleBudget />
      </TabPanel>
      {enableDetailedBudget &&
        <TabPanel>
          <DetailedBudget
            isRetired={isRetired}
            readOnly={readOnly}
            budgetCategories={budgetCategories}
          />
        </TabPanel>
      }
    </Tabs>
  )
}

const TabHeader = ({ selected, selectedTab, enableDetailedBudget }) => {
  const { state: { isRetired } } = useContext(BudgetContext)
  const { readOnly } = useContext(ActionablesContext)
  return (
    <Box flex='1'>
      <h2>Budget</h2>
      <p>You are using <strong>{selected === 0 ? 'simple' : 'detailed'}</strong> expenses.</p>
      {!enableDetailedBudget &&
        <p><strong>The detailed budget is only available on desktop.</strong></p>
      }
      {selectedTab === 1 && !readOnly && !isRetired &&
        <CheckboxWithLabel
          label='Use current expenses for retirement'
          name='use_current_expense_for_retirement'
          size='small'
        />
      }
    </Box>
  )
}
